import { default as borderRadiusValues } from './border-radius-generated';
export default borderRadiusValues;